import { render, staticRenderFns } from "./IdentityVerificationReturn.vue?vue&type=template&id=d8be8aa6&scoped=true"
import script from "./IdentityVerificationReturn.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationReturn.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerificationReturn.vue?vue&type=style&index=0&id=d8be8aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8be8aa6",
  null
  
)

export default component.exports